webpackJsonp([99549205978704],{

/***/ 1587:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"TriggerInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"if","type":{"kind":"ENUM","name":"TriggerIf","ofType":null}},{"defaultValue":null,"description":null,"name":"on","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"options","type":{"kind":"SCALAR","name":"JSON","ofType":null}},{"defaultValue":null,"description":null,"name":"then","type":{"kind":"ENUM","name":"TriggerThen","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-trigger-input-20d2f18c68263debcb92.js